// Devuelve true si es necesario redireccionar o la acción necesaria
//

export function isAuthTokenByPath(path) {
    if (localStorage.getItem("jwtToken")) {
        if (path.pathname.indexOf('login') > 0) {
            return true;
        }

        return false;
    } else {
        if (path.pathname.indexOf('login') > 0)  {
            return false;
        }

        return true;
        
    }
}
